import React from "react";
import {CreateLobbyProps, HostFormVerticalSpace} from "engage-client/pages/host";
import Checkbox from "engage-client/components/Checkbox";
import {createUseStyles} from "react-jss";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import RadioGroup, {Radio} from "engage-client/components/RadioGroup";
import clsx from "clsx";
import {ThemeNames, Themes} from "engage-client/theme";

const useStyles = createUseStyles({
	checkbox: {
		marginTop: HostFormVerticalSpace
	},
	label: {
		marginTop: HostFormVerticalSpace,
		marginLeft: 44
	},
	imageContainer: {
		display: "flex",
		alignItems:"center",
		justifyContent:"space-between",
		height: 152,
		gap: 2
	},
	image: {
		width: 120,
		transition: "width 250ms ease-in-out"
	},
	activeImage: {
		width: 250,
	}
});

export default function CreateLobby({formValues, handleInputChange, separatorClass, setFormValue}:CreateLobbyProps) {
	const classes = useStyles();
	const currentTheme = formValues.themeId ?? Themes.brand2025;
	return (
		<>
			<div className={separatorClass}/>
			<DisplayText variant={TextVariant.s18reg} className={classes.label}>Trivia Theme</DisplayText>
			<RadioGroup name="themeId"
						value={currentTheme}
						horizontal={true}
						onChange={(e) => {setFormValue("themeId", e.target.value);}} >
				<Radio value={Themes.brand2025}
						labelText={ThemeNames[Themes.brand2025]}
						labelVariant={TextVariant.s16reg}/>
				<Radio value={Themes.brand2023}
					   labelText={ThemeNames[Themes.brand2023]}
					   labelVariant={TextVariant.s16reg}/>
				<Radio value={Themes.classic}
					   labelText={ThemeNames[Themes.classic]}
					   labelVariant={TextVariant.s16reg}/>
			</RadioGroup>
			<div className={classes.imageContainer}>
				<img src="/assets/theme-previews/brand2025-small.png"
					 className={clsx(classes.image, currentTheme === Themes.brand2025 && classes.activeImage)}
					 alt="Brand 2025 theme - light blue and modern"/>
				<img src="/assets/theme-previews/brand2023-small.png"
					 className={clsx(classes.image, currentTheme === Themes.brand2023 && classes.activeImage)}
					 alt="Brand 2023 theme - light blue and modern"/>
				<img src="/assets/theme-previews/classic-small.png"
					 className={clsx(classes.image, currentTheme === Themes.classic && classes.activeImage)}
					 alt="Classic theme - darker theme with more gradients"/>
			</div>
			<div className={separatorClass}/>
		</>
	);

};